<template>
    <div>
        <h1>Экспорт</h1>
        <div>
            <span class="btn" @click="checkAll()">{{!checkedAll ? 'Выбрать все' : 'Отменить выбор'}}</span>&nbsp;
            <span class="btn" :class="canExport ? '' : 'disabled'" @click="getPrintJSON()">Экспортировать выбранное</span>
        </div>
        <div v-if="printJSON" class="card-panel" style="white-space: pre-line;">
            <button class="btn" @click="forceFileDownload()">Скачать</button>
            <br>
            {{JSON.stringify(printJSON, null, 1)}}
        </div>
        <div v-for="item of items" :key="item._id+keyPlus" style="margin-top:30px;">
            <div>
                <label>
                    <input type="checkbox" v-model="item.checked"/>
                    <span>Экспортировать</span>
                </label>
                <router-link class="btn-flat" :to="'/question/'+item._id" style="color:#404040;">
                    Переоформить
                </router-link>
            </div>
            <div class="card-panel" :for="'cb'+item._id">{{item.text}}</div>
        </div>
    </div>
</template>

<script>
import stitchedCategories from '@/mixins/stitchedCategoriesMixin'

export default {
    mixins:[stitchedCategories],
    data(){
        return {
            items:[],
            keyPlus: 0,
            checkedAll: false,
            printJSON: ''
        }
    },
    computed:{
        canExport(){
            return this.items.some(item => item.checked === true)
        }
    },
    methods:{
        checkAll(){
            this.checkedAll = !this.checkedAll
            this.items.forEach(item => item.checked = this.checkedAll )
            //this.keyPlus = this.keyPlus+1
        },
        async getPrintJSON(){

            const fullUrlPrefix = "https://reshimvse.com/api/";

            const myDateFormat = (timestamp) => new Date(timestamp).toLocaleDateString()+' '+new Date(timestamp).toLocaleTimeString()

            const exportedItems = this.items
                                            .filter(item => item.checked === true)
                                            .map(item => { 

                                                /**
                                                 * Приводоим ответы у удобному для импорта в архив формату
                                                 * 1) Меняем дату
                                                 * 2) isBest делаем числом 0 или 1
                                                 * 3) Изображения строкой с полной ссылкой
                                                 */
                                                const answers_id = item.answers_id.map(answer => {

                                                    return {
                                                        ...answer,
                                                        createdAt: answer.createdAt ? myDateFormat(answer.createdAt) : myDateFormat(item.createdAt),
                                                        isBest: Number(answer.isBest) || Number(answer.isConfirmedFinal),
                                                        imgs: [...answer.imgs].map(img=>`${fullUrlPrefix}${img}`).join(','),
                                                        finalAnswer: answer.final || ""
                                                    }
                                                })
                                                
                                                /**
                                                 * Приводим вопрос к удобному для импорта в архив
                                                 * 1) Меняем дату
                                                 * 2) Дисциплина и уровень в текст
                                                 * 3) Изборажения строкой с полной ссылкой
                                                 */
                                                return {
                                                    ...item, 
                                                    createdAt: myDateFormat(item.createdAt),
                                                    discipline: this.convCodeToName(item.discipline, 'disciplines'),
                                                    level: this.convCodeToName(item.level, 'levels').split(' ')[0],
                                                    imgs: [...item.imgs].map(img=>`${fullUrlPrefix}${img}`).join(','),
                                                    answers_id
                                                } 
                                            })

            const arrayOfQuestionsId = exportedItems.map(item => item._id)

            const res = (await this.$axios.put('/export/setExported', {arrayOfQuestionsId})).data

            if(res){
                this.printJSON = exportedItems
            }
                
        },
        forceFileDownload(){
            const url = 'data:application/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(this.printJSON, null, 1))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', `export_${this.printJSON.length}_${Date.now()}.json`) //or any other extension
            document.body.appendChild(link)
            link.click()
        }
    },
    async created(){
        this.items = (await this.$axios.get('/export/get_questions_for_export')).data
        //this.items.forEach(item => item.checked = false )

        //ДОБАВЛЯЕМ РЕАКТИВНОЕ СВОЙСТВО
        this.items.forEach(item => this.$set(item, 'checked', false))
        
    }
}
</script>